import React from 'react';

const title = 'We’re sorry. An unexpected error occurred.';
const message = 'Please try again later or contact us directly.';

export const ErrorBoundaryHandler = ({ componentStack, error }: { componentStack?: string; error?: Error }) => {
    return (
        <div
            className="background-image"
            style={{
                position: 'fixed',
                top: 0,
                right: 0,
                bottom: 0,
                left: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '2rem',
            }}>
            <div
                className="alert alert-danger"
                style={{
                    width: '80%',
                    height: '60%',
                    maxWidth: '1200px',
                    minHeight: 0,
                    padding: '2rem',
                    boxSizing: 'border-box',
                    overflow: 'auto',
                    margin: 0,
                    borderRadius: '8px',
                    boxShadow: '0 8px 30px rgba(0, 0, 0, 0.15)',
                }}>
                <h2 style={{ margin: '0 0 0.5rem' }}>{title}</h2>

                <div style={{ marginBottom: '1.5rem' }}>{message}</div>

                {error != null && (
                    <details>
                        <summary
                            style={{
                                cursor: 'pointer',
                                fontWeight: 600,
                                padding: '0.5rem 0',
                            }}>
                            Error details
                        </summary>

                        <div
                            style={{
                                marginTop: '0.5rem',
                                padding: '1rem',
                                backgroundColor: 'rgba(255, 255, 255, 0.2)',
                                border: '1px solid rgba(255, 255, 255, 0.3)',
                                borderRadius: '4px',
                                overflow: 'auto',
                            }}>
                            <p style={{ margin: '0 0 1rem' }}>
                                <strong>{error.name}</strong>
                                {error.message && `: ${error.message}`}
                            </p>

                            {error.stack != null && (
                                <details>
                                    <summary
                                        style={{
                                            cursor: 'pointer',
                                            fontWeight: 500,
                                        }}>
                                        Stack trace
                                    </summary>

                                    <pre
                                        style={{
                                            margin: '0.75rem 0 0',
                                            padding: '0.75rem',
                                            overflow: 'auto',
                                            fontSize: '0.85rem',
                                            lineHeight: 1.4,
                                            whiteSpace: 'pre-wrap',
                                            wordBreak: 'break-word',
                                            backgroundColor: 'rgba(0, 0, 0, 0.12)',
                                            border: '1px solid rgba(255, 255, 255, 0.2)',
                                            borderRadius: '4px',
                                            color: 'inherit',
                                        }}>
                                        {error.stack}
                                    </pre>
                                </details>
                            )}
                        </div>
                    </details>
                )}

                {componentStack != null && (
                    <details style={{ marginTop: '1rem' }}>
                        <summary
                            style={{
                                cursor: 'pointer',
                                fontWeight: 600,
                                padding: '0.5rem 0',
                            }}>
                            Component stack
                        </summary>

                        <pre
                            style={{
                                margin: '0.5rem 0 0',
                                padding: '1rem',
                                maxHeight: '20rem',
                                overflow: 'auto',
                                fontSize: '0.85rem',
                                lineHeight: 1.4,
                                whiteSpace: 'pre-wrap',
                                wordBreak: 'break-word',
                                backgroundColor: 'rgba(0, 0, 0, 0.12)',
                                border: '1px solid rgba(255, 255, 255, 0.2)',
                                borderRadius: '4px',
                                color: 'inherit',
                            }}>
                            {componentStack}
                        </pre>
                    </details>
                )}
            </div>
        </div>
    );
};
